module.exports = {
          srcSet: __webpack_public_path__ + "cd94de0f.png"+" 367w",
          images:[ {path: __webpack_public_path__ + "cd94de0f.png",width: 367,height: 200}],
          src: __webpack_public_path__ + "cd94de0f.png",
          toString:function(){return __webpack_public_path__ + "cd94de0f.png"},
          
          width: 367,
          height: 200
        }